var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_3853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6543 0.389359C9.87554 0.141585 9.02603 0 8.15882 0C5.66338 0 3.41572 1.13268 1.91138 2.92019L5.76957 6.15895L10.6543 0.389359Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9114 2.92017C0.725624 4.33602 0 6.17662 0 8.15881C0 9.69855 0.300868 10.9374 0.814114 12.0524L5.76959 6.15893L1.9114 2.92017Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17648 5.04401C9.9109 5.04401 11.309 6.44217 11.309 8.17658C11.309 8.9376 11.0259 9.64553 10.5657 10.1942C10.5657 10.1942 13.0258 7.25628 15.4327 4.40688C14.4416 2.49548 12.7249 1.04424 10.6542 0.389404L5.76953 6.159C6.35357 5.48647 7.20308 5.04401 8.17648 5.04401Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17651 11.2914C6.44209 11.2914 5.04394 9.89324 5.04394 8.15882C5.04394 7.3978 5.30941 6.68988 5.76956 6.15894L0.814087 12.0524C1.6636 13.9284 3.07945 15.4505 4.5307 17.3442L10.5658 10.1764C9.98172 10.8666 9.13221 11.2914 8.17651 11.2914Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4596 19.3264C13.1852 15.0611 16.3531 13.132 16.3531 8.17656C16.3531 6.81381 16.0169 5.53954 15.4328 4.40686L4.53076 17.3442C4.99091 17.9459 5.46876 18.6362 5.92891 19.3441C7.59254 21.9103 7.13239 23.4324 8.19428 23.4324C9.25616 23.4324 8.79601 21.8926 10.4596 19.3264Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_3853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3902,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/Google_Map.5a67683f943bc678cc866cfaa9eaa299.svg";
export { ForwardRef as ReactComponent };